export default "__VITE_ASSET__BvJpg92y__"